import ajax from './ajaxStatusReducer';
import {combineReducers} from 'redux';
const rootReducer = combineReducers({
  ajax
  
});

export default rootReducer;